import React, { useState, useEffect, useRef } from 'react';
import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import { useContextData } from '../ContextData';
import * as request from "../../services/FetchService";
import { staticSort } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import ReactMarkdown from 'react-markdown';

const OpenSupportTicketModal = ({ show, ticketId, onClose, updateList }) => {
    const bottomRef = useRef(null);
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const { deviceListCompact } = useContextData();
    const [deviceList, setDeviceList] = useState()
    const [selectedDevice, setSelectedDevice] = useState(-1)
    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false)
    const [comments, setComments] = useState([])
    const [ticketOpen, setTicketOpen] = useState(false)
    const [loading, setLoading] = useState(true)

    const handleClose = () => {
        onClose()
        setComments([])
        setTicketOpen(false)
        setLoading(true)
      //  setShow(false)
    }
    const getSpecificTicket = () => {
        const data = {
            ticketid: ticketId
        }
        request.post("", "account/support/tickets/specific", data).then((response) => {
            const status = response?.data?.ticket?.can_reply
            setLoading(false)
            setTicketOpen(status)
            const sorted = staticSort(response?.data?.ticket?.comments, "created_at")
            setComments(sorted)        
            console.log("REPSONSE FOR TICKET: ", response)
            toast.dismiss("opening");
        }); 
    }

    useEffect(() => {
        if (!loading && comments.length > 0) {
            setTimeout(() => {
                bottomRef.current?.scrollIntoView({ behavior: "auto" });
            }, 50);
        }
    }, [loading, comments]);

    useEffect(() => {
       // getDevices()
       if(show){
            getSpecificTicket()
       }
    }, [show])

    const sendMessage = async () => {

        if(!message || message === ""){
            toast.error(t("toast.no_message"))
            return
        }
        let data = {
            ticketid: ticketId,
            message
        }

        console.log("DATA?: ", data)
        request.post("", "account/support/tickets/update", data).then((response) => {
            if(response.data.successful){
                toast.success(t("toast.sent"))
                getSpecificTicket()
                setMessage("")
                updateList()
            }
		}); 
    }
    
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : true} maxWidth="md" open={!loading && show} onClose={handleClose}>
            <Card className="in_app_message_dialog">
                <div className="w-100 h-100">
                    <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                        <div className='d-flex align-items-center'>
                            <img src={icons.questionmark} alt=""/>
                            <h3 className="ms-2">{t("settings.new_ticket")}</h3>
                        </div>
                        <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
                    </div>
                    <div className="p-3 d-flex flex-column ticket-list w-100">
                        {comments?.map((comment, index) => {
                            return(
                                <div key={index} className={`markdown-body chatbubble p-3 mb-3 ${comment.from === "user" ? "bg-primary align-self-end rounded" : "bg-grey align-self-start rounded"}`}>
                                    
                                    <ReactMarkdown>{comment.body}</ReactMarkdown>

                                    {/* <p>{comment?.body}</p> */}
                                </div>
                            )
                        })}
                        <div ref={bottomRef} />
                    </div>
                    <div className={`${ticketOpen ? "" : "d-none"} p-3 border-settings-top`}>
                        <textarea rows={5} value={message} onChange={(event) => setMessage(event.target.value)} className="locked-size form-control bg-light-grey" /> 
                    </div>
                    <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
                        <Button onClick={() => handleClose()} btnClass={`btn-secondary ${ticketOpen ? "me-2" : ""}`}>{ticketOpen ? t("settings.cancel") : t("settings.close")}</Button>

                        <Button onClick={() => sendMessage()} btnClass={`btn-primary ${ticketOpen ? "" : "d-none"} ${messageSent ? "disabled" : ""}`}>{messageSent ? t("settings.sent") : t("settings.send")}</Button>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default OpenSupportTicketModal;